/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/destructuring-assignment */
import Card from '@material-ui/core/Card';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Switch from '@material-ui/core/Switch';
import Typography from '@material-ui/core/Typography';
import ArchiveIcon from '@material-ui/icons/Archive';
import BarChartIcon from '@material-ui/icons/BarChart';
import EditIcon from '@material-ui/icons/Edit';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import ShareIcon from '@material-ui/icons/Share';
import start from '@orientaction/Asset/Favorite/start.png';
import { ChipTime } from '@orientaction/commons';
import { useCategoryTest, useTest } from '@orientaction/hooks';
import { publicSvgPath } from '@orientaction/utils';
import clsx from 'clsx';
import { kebabCase } from 'lodash';
// eslint-disable-next-line no-use-before-define
import React from 'react';
import { useHistory } from 'react-router-dom';
import AnalyticsDrawer from '../AnalyticsDrawer';
import ShareModal from '../ShareModal';
import { useStyles } from './style';

class ErrorBoundary extends React.Component<any, { hasError: boolean; error: any }> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: any) {
    return { hasError: true, error };
  }

  componentDidCatch(error: any, errorInfo: any) {
    // Log error if needed
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ color: 'red', padding: 32, background: '#fff' }}>
          <h2>Erreur dans AnalyticsDrawer</h2>
          <pre>{String(this.state.error)}</pre>
        </div>
      );
    }
    return this.props.children;
  }
}

const CardTest = (props: any) => {
  const classes = useStyles();
  const link = `${process.env.REACT_APP_SHARE_ENDPOINT}/api/test/${props.id}/${kebabCase(
    props.title
  )}`;
  const englishUrlPrefix = `.../api/test/${props.id}/`;
  const englishBaseUrl = `${process.env.REACT_APP_SHARE_ENDPOINT_EN}/api/test/${props.id}/`;
  const [checkedC, setStateC] = React.useState(!props.isDesabled);
  const [opacity, setOpacity] = React.useState(1);
  const [filter, setFilter] = React.useState('grayscale(0%)');
  const [openModal, setOpenModal] = React.useState(false);
  const [openAnalyticsDrawer, setOpenAnalyticsDrawer] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const { push } = useHistory();
  const { desableTest, deepDuplicateTest, putTest } = useTest();
  const { list, setList } = useCategoryTest();
  const [slugEnP, setSlugEnP] = React.useState<string>(props.slugEn || '');

  const handleChange = (event: any) => {
    disableCard(!event.target.checked);
    setStateC(event.target.checked);
  };
  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleSaveSlug = async (slug: string) => {
    try {
      await putTest(String(props.id), { slugEn: slug });
      setSlugEnP(slug);
    } catch (err) {
      console.error('Erreur lors de la sauvegarde du slug :', err);
    }
  };
  const handleOpenAnalyticsDrawer = () => {
    setOpenAnalyticsDrawer(true);
  };
  const handleCloseAnalyticsDrawer = () => {
    setOpenAnalyticsDrawer(false);
  };
  const duplicateCard = () => {
    setLoading(true);
    deepDuplicateTest(props.id).then(() => setLoading(false));
  };

  const archiveCard = async () => {
    const { id, isArchived } = props;
    const data = {
      isArchived: !isArchived,
      isDesabled: false,
      category_test: props.category, // default one
      currentCategory: props.category,
    };
    await desableTest(id, { ...data });

    if (!isArchived) {
      const updatedList = list.map((category: any) => {
        const updatedContentList =
          category.contentList?.filter((test: any) => test.id !== id) || [];
        return {
          ...category,
          contentList: updatedContentList,
        };
      });
      setList(updatedList);
    }
  };

  const disableCard = async (handleChecked: boolean) => {
    const data = {
      isDesabled: handleChecked,
      isArchived: false,
      category_test: props.category, // default one
      currentCategory: props.category,
    };
    const { id } = props;
    await desableTest(id, { ...data });

    if (handleChecked) {
      const updatedList = list.map((category: any) => {
        const updatedContentList =
          category.contentList?.filter((test: any) => test.id !== id) || [];
        return {
          ...category,
          contentList: updatedContentList,
        };
      });
      setList(updatedList);
    }
  };

  React.useEffect(() => {
    if (props.isArchived) {
      setOpacity(0.7);
      setFilter('grayscale(100%)');
    }
  }, [props.isArchived]);

  const modifyTest = (testId: any) => () => {
    push(`/admin/test/${testId}/modifier`);
  };

  return (
    <>
      <div className={classes.root}>
        <Card
          className={clsx({
            [classes.cardContainer]: true,
          })}
          style={{ opacity, filter }}>
          <Grid container={true} spacing={3}>
            {props.isFavorite ? (
              <Grid item={true} xs={12}>
                <div className={classes.contentImgFavorite}>
                  <div
                    className={classes.imgFavorite}
                    style={{
                      backgroundImage: `url(${
                        props.thumbnail && props.thumbnail !== ''
                          ? props.thumbnail
                          : props.image && props.image !== ''
                          ? props.image
                          : `${publicSvgPath}/QR.png`
                      })`,
                    }}
                  />
                </div>
              </Grid>
            ) : (
              <Grid item={true}>
                <img
                  className={classes.img}
                  src={
                    props.thumbnail && props.thumbnail !== ''
                      ? props.thumbnail
                      : props.image && props.image !== ''
                      ? props.image
                      : `${publicSvgPath}/QR.png`
                  }
                  alt="logo"
                />
              </Grid>
            )}

            <Grid item={true} xs={true}>
              {!!props.isFavorite && <img src={start} className={classes.start} alt="Favorite" />}

              {props.showStatusChip && (
                <span
                  className={
                    props.isArchived
                      ? classes.chipArchived
                      : props.isDesabled
                      ? classes.chipDisabled
                      : classes.chipActive
                  }>
                  {props.isArchived ? 'Archivé' : props.isDesabled ? 'Désactivé' : 'Actif'}
                </span>
              )}

              <Typography
                variant="h6"
                component="h6"
                color="primary"
                className={classes.fontTitleCard}>
                {' '}
                {props.title}
              </Typography>
              <div className={classes.positionAbsolute}>
                <div className={classes.marginChip}>
                  <ChipTime time={props.time} />
                </div>
                <div className={classes.controls}>
                  <IconButton className={classes.btnIcon} onClick={modifyTest(props.id)}>
                    <EditIcon className={classes.styleIcon} />
                  </IconButton>
                  <IconButton className={classes.btnIcon}>
                    {loading ? (
                      <CircularProgress color="primary" size={14} />
                    ) : (
                      <FileCopyIcon
                        data-cy="duplicate-test"
                        className={classes.styleIcon}
                        onClick={duplicateCard}
                      />
                    )}
                  </IconButton>
                  <IconButton className={classes.btnIcon} onClick={handleOpenModal}>
                    <ShareIcon className={classes.styleIcon} />
                  </IconButton>
                  <IconButton className={classes.btnIcon} onClick={handleOpenAnalyticsDrawer}>
                    <BarChartIcon className={classes.styleIcon} />
                  </IconButton>
                  <IconButton className={classes.btnIcon}>
                    <ArchiveIcon
                      data-cy="archive-test"
                      className={classes.styleIcon}
                      onClick={archiveCard}
                    />
                  </IconButton>
                  <div style={{ float: 'right' }}>
                    <Switch
                      checked={checkedC}
                      onChange={handleChange}
                      name="checkedA"
                      inputProps={{ 'aria-label': 'secondary checkbox' }}
                      color="primary"
                    />
                  </div>
                </div>
              </div>

              {props.isFavorite && <div className={classes.bouttom} />}
            </Grid>
          </Grid>
          <ShareModal
            open={openModal}
            onClose={() => setOpenModal(false)}
            title="test"
            shareUrl={link}
            englishUrlPrefix={englishUrlPrefix}
            englishSlug={slugEnP}
            onSaveSlug={handleSaveSlug}
            showSlugChangeWarning={true}
            englishBaseUrl={englishBaseUrl}
          />
        </Card>
      </div>

      <ErrorBoundary>
        <AnalyticsDrawer
          open={openAnalyticsDrawer}
          testId={props.id}
          testTitle={props.title}
          onClose={handleCloseAnalyticsDrawer}
        />
      </ErrorBoundary>
    </>
  );
};

export default CardTest;
